import { render } from "./ApiDocPage.vue?vue&type=template&id=5af57734&scoped=true"
import script from "./ApiDocPage.vue?vue&type=script&lang=js"
export * from "./ApiDocPage.vue?vue&type=script&lang=js"

import "./ApiDocPage.vue?vue&type=style&index=0&id=5af57734&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af57734"]])

export default __exports__